"use client";

import HomePersonalizedDemoCTA from "./HomePersonalizedDemoCTA";
import PricingPersonalizedDemoCTA from "./PricingPersonalizedDemoCTA";

type PersonalizedDemoCTAVariant = "HOME" | "PRICING";

/** Selects presentation only; both variants share one acquisition form flow. */
export default function PersonalizedDemoCTA({
  variant = "HOME",
}: {
  variant?: PersonalizedDemoCTAVariant;
}) {
  if (variant === "PRICING") return <PricingPersonalizedDemoCTA />;
  return <HomePersonalizedDemoCTA />;
}

